import { Helmet } from "react-helmet";
import ResizableHeader from "@/components/ResizableHeader";
import Features from "@/components/Features";
import Footer from "@/components/Footer";

const FeaturesPage = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Features | BankConvert</title>
        <meta name="description" content="See what BankConvert can do: instant PDF-to-Excel conversion, 99.9% accuracy, multi-bank support, and private in-browser processing." />
        <link rel="canonical" href="https://www.bankconvert.org/features" />
      </Helmet>
      <ResizableHeader />
      <main>
        <Features />
      </main>
      <Footer />
    </div>
  );
};

export default FeaturesPage;
